import React from 'react'

const MediaCard1Section4 = (props) => {
  return (
    <div className=" p-1">
    <img
      alt="gallery"
      className="block h-full  rounded-lg object-cover object-center lg:h-[30vh]  "
      src={props.image1}
    />
  </div>
  )
}

export default MediaCard1Section4